import { makeStyles, Theme } from "@material-ui/core";

export const stylesSelect = makeStyles((theme: Theme) => ({
  root: {
    minWidth: "120px",
  }
}));
